<template>
	<div>
		<el-form :inline="true">
			<el-form-item label="用户昵称">
				<el-input v-model="searchForm.name" placeholder="用户昵称" clearable></el-input>
			</el-form-item>
			<el-form-item label="优惠券名称">
				<el-input v-model="searchForm.couponsName" placeholder="优惠券名称" clearable></el-input>
			</el-form-item>
			<el-form-item label="优惠券状态" label-width="100">
				<el-select v-model="searchForm.type" clearable placeholder="选择订单状态">
					<el-option label="已使用" value="1"></el-option>
					<el-option label="未使用" value="2"></el-option>
					<el-option label="已过期" value="3"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button @click="getsch" type="success">搜索</el-button>
			</el-form-item>
		</el-form>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border stripe
			@selection-change="handleSelectionChange">
			<el-table-column label="优惠券名称" align="center" prop="name"></el-table-column>
			<el-table-column prop="waysObtain" align="center" label="优惠券状态" width="140">
				<template slot-scope="scope">
					<div v-if="scope.row.employ == 0&&scope.row.isOverdue == 0" type="success"> 未使用</div>
					<div v-else-if="scope.row.employ == 1" type="success">已使用</div>
					<div v-else-if="scope.row.employ == 0&&scope.row.isOverdue == 1" type="success">已过期</div>
				</template>
			</el-table-column>
			<el-table-column prop="nickName" align="center" width="140" label="用户名称"></el-table-column>
			<el-table-column prop="phone" align="center" width="120" label="用户手机号"></el-table-column>
			<el-table-column prop="rulesType" align="center" label="优惠规则类型" width="120">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.type === 2" type="success"> 满减 </el-tag>
					<el-tag size="small" v-else-if="scope.row.type === 1" type="success"> 无门槛 </el-tag>
				</template>
			</el-table-column>

			<el-table-column align="center" label="满减条件" prop="satisfyAmount" width="120"></el-table-column>
			<el-table-column align="center" label="优惠金额" prop="discountAmount" width="120"></el-table-column>
			<el-table-column prop="createTime" align="center"  label="有效时间">
				<template slot-scope="scope">
				{{scope.row.startTime}} -{{scope.row.endTime}}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" prop="icon" fixed="right" width="120">
				<template slot-scope="scope">
					<el-popconfirm title="确定删除吗？" @confirm="delHandle(scope.row.id)"  v-if="hasAuth('sys:coupuser:del')">
						<el-button type="danger" plain slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total">
		</el-pagination>



	</div>
</template>
<script>
	import VploadImg from "../inc/VploadImgThree";
	export default {
		name: "ConfigType",
		components: {
			VploadImg
		},
		data() {
			return {
				searchForm: {},
				shopForm: {},
				delBtlStatu: true,
				tableData: [],
				multipleSelection: [],
				filesd: [],
				editForm: {},
				total: 0,
				size: 10,
				current: 1,
				dialogVisible: false,
				name: "",
				sort: 0,
				id: '',
			}
		},
		created() {
			this.getConfigType();
			// this.getTypeList()


		},
		methods: {
			// getTypeList() {
			// 	this.$axios.post("/admin/sysCouponSheet/getList" ).then(res => {
			// 		this.typeList = res.data;
			// 	})
			// },
			delHandle(id) {
				this.$axios.post("/admin/brand/delete", {
					id: id
				}).then(res => {
					this.getConfigType()
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {

						}
					});
				})
			},



			getsch() {
				this.current = 1
				this.getConfigType()
			},
			getImg(url, add) {

				if (add == 1) {
					this.imgUrl = url
				} else if (add == 0) {
					this.imgUrl = ''
				}

			},

			handleClose() {
				this.dialogVisible = false
			},



			submitForm() {

				if (this.id) {
					this.$axios.post("/admin/homeCarouse/updateHomeCarouse", {
						id: this.id,
						imgUrl: this.imgUrl,
						name: this.name,
						sort: this.sort,
						state: 1,


					}).then(res => {
						this.dialogVisible = false
						this.getConfigType()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
				} else {
					this.$axios.post("/admin/brand/add", {
						cover: this.imgUrl,
						name: this.name,
						sort: this.sort,


					}).then(res => {
						this.dialogVisible = false
						this.getConfigType()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
				}

			},

			handleSelectionChange(val) {
				this.multipleSelection = val;
				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				this.size = val
				this.getConfigType()
			},
			handleCurrentChange(val) {
				this.current = val
				this.getConfigType()
			},


			//获取常量数据配置列表
			getConfigType() {
				this.$axios.post("/admin/sysCouponSheet/grantIssueCoupon", {
					pageNo: this.current,
					pageSize: this.size,
					couponsName: this.searchForm.couponsName,
					name: this.searchForm.name,
					type: this.searchForm.type,
				}).then(res => {
					this.tableData = res.data.records
					this.size = res.data.size
					this.current = res.data.current
					this.total = res.data.total
				})
			},
			UpdateConfigTypeButton(id) {

				this.id = id.id
				this.imgUrl = id.imgUrl
				this.name = id.name
				this.filesd = []
				var fles = {
					url: id.imgUrl
				}
				this.filesd.push(fles)
				this.dialogVisible = true
			},
		}
	}
</script>

<style scoped>
	.el-button {
		padding: 0 10px;
		height: 35px;
		line-height: 35px;
		font-size: 15px;
		margin-right: 10px;
	}
</style>
